<template>
  <main class="mt-2">
    <section v-if="statusData?.hasRequiredMonthsBankStatement === '' && statusData.processingType === '' && !statusData.bankStatementProcessed ||
        statusData?.hasRequiredMonthsBankStatement === 'false' && statusData.processingType === 'instant' && statusData.bankStatementProcessed ||
        statusData.processingType === 'manual' && profileBankDocCount === 0"
      class="grid gap-3 items-center pt-4">
      <div>
        <p class="label-text-medium">Bank Statement</p>
        <p class="secondary-heading-text">Get a higher limit by verifying your bank statement.</p>
      </div>
      <button @click.prevent="toggleModal()" class="w-full py-1 rounded-xl bg-white border border-gray-100 shadow-lg">
        <div class="flex items-center justify-between py-2 gap-20">
          <!-- File Details Section -->
          <div class="flex items-center p-2">
            <span class="label-text-myriad px-2">Verify Your Bank Statement</span>
          </div>
        </div>
      </button>
    </section>
    <!-- Trigger Section -->
    <section v-else class="grid gap-3 items-center pt-4">
      <div class="flex gap-2 items-center">
        <p class="label-text-medium">Bank Statement</p>
      </div>
      <div class="shadow-cardShadow w-full rounded-lg bg-white">
        <article class="flex justify-between items-center py-4 pl-3 pr-6">
          <div class="flex gap-3 items-center">
            <div v-if="statusData?.hasRequiredMonthsBankStatement === 'true'" class="w-7 h-7 ml-3">
              <Vue3Lottie :animationData="GreenCheckAnimation" :speed="1" :loop="true" />
            </div>
            <div v-else>
              <img src="../assets/orange-tick.svg" alt="orange tick" height="24" width="24">
            </div>
            <span class="grid gap-0.5">
              <p
                v-if="statusData?.hasRequiredMonthsBankStatement === 'true' && statusData.processingType === 'instant'"
                class="label-text-medium"
              >
                Instant Bank Statement
              </p>
              <p v-else class="label-text-medium">Bank Statement</p>
              <p v-if="statusData?.hasRequiredMonthsBankStatement === 'true'"
                class="secondary-heading-text">
                Verified Successfully
              </p>
              <p v-else class="secondary-heading-text">Under Review</p>
            </span>
          </div>
          <div
            v-if="statusData?.hasRequiredMonthsBankStatement === 'false' && statusData.processingType === 'manual'"
            @click.prevent="toggleModal('add more')"
            class="font-blogger font-semibold text-xs text-primary underline">
            Add More
          </div>
        </article>
      </div>
    </section>
    <router-view>
      <sidebar
        :isPanelOpen="isPanelOpen"
        @closeSidebarPanel="isPanelOpen = false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div @submit="isPanelOpen = false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Bank Statement</h2>
        </section>
        <div class="grid gap-4 mb-10 mx-4">
          <div
            class="flex gap-4 items-center px-4 py-5 rounded-xl cursor-pointer bg-white"
            v-for="(docType, index) in visibleDocumentTypes"
            :key="index"
            @click="docType.name === 'Upload Manually' ? selectDocument() : thirdPartyMethodCall(docType.name)"
          >
            <img :src="docType.imgUrl" :alt="docType.displayText" class="w-12" />
            <div class="grid">
              <p class="label-text-medium">{{ docType.displayText }}</p>
              <p class="label-text-myriad">{{ docType.subText }}</p>
            </div>
          </div>
          <div>
            <p v-if="!showUploadManually"  @click.prevent="toggleOtherOption" class="secondary-heading-text-blogger text-primary font-semibold text-center underline">
              Other option
            </p>
          </div>
          <div class="flex gap-2 items-center">
            <img src="../assets/info-blue-icon.svg" alt="Info Icon" width="14" height="14"/>
            <p class="label-text-headingColor-myriad font-bold">Choose your primary accounts for a better limit.</p>
          </div>
        </div>
      </sidebar>
    </router-view>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
  </main>
</template>

  <script>
  import { mapGetters } from 'vuex';
  import Sidebar from '../components/Sidebar.vue';
  import GreenCheckAnimation from '../assets/animation/green_check_animation.json';
  import SpinLoader from '../components/spinLoader.vue';

  export default {
    name: "UploadBankStatement",
    components: {
      Sidebar,
      SpinLoader
    },
    props: {
      profileBankDocCount: {
        type: Number,
        required: false,
        default: 0,
      },
      toggleChangeBank: {
        type: String,
        required: false,
        default: undefined,
      },
      statusData: {
        type: Object,
        default: undefined,
      }
    },
    watch: {
      toggleChangeBank(newVal) {
        if (newVal === 'shift_tab') {
          this.toggleChangeOrder();
        } else if (newVal === 'open_tab') {
          this.isPanelOpen = true;
        } else {
          this.isPanelOpen = false;
        }
      }
    },
    data() {
      return {
        isPanelOpen: undefined,
        customPanelHeight: 'auto',
        isSpinLoading: undefined,
        GreenCheckAnimation,
        uploadedDocuments: undefined,
        showUploadManually: false,
        swapped: false,
        popUpMessage: {
          message1: '• Take a photo of the bank statement clearly visible'
        },
        documentTypes: [
          {
            displayText: 'Instant Verification',
            name: 'Get Instant Verification',
            subText: 'Free & Secure',
            imgUrl: require('@/assets/insta-download.svg'),
          },
          {
            displayText: 'Upload Manually',
            name: 'Upload Manually',
            subText: 'Upload 6-month statement. Verification takes 24–48 hrs.',
            imgUrl: require('@/assets/upload-manually.svg'),
          }
        ],
      };
    },
    computed: {
      ...mapGetters(['applicationId']),
      visibleDocumentTypes() {
        if (!this.showUploadManually) {
          // Hide Upload Manually initially
          return this.documentTypes.filter(
            (doc) => doc.name !== 'Upload Manually'
          );
        }
        // Show both, depending on swapped order
        return this.swapped
          ? [...this.documentTypes].reverse()
          : this.documentTypes;
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
      },
      toggleChangeOrder() {
        this.isPanelOpen = true;
        this.showUploadManually = true;
        this.swapped = true;
      },
      toggleOtherOption() {
        this.showUploadManually = !this.showUploadManually;
      },
      toggleModal(check) {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_CLICKED, {
          [this.$mixpanelPayload.KEY_CLICK]: check
        });
        if (check === 'add more') {
          this.showUploadManually = true;
        }
        this.isPanelOpen = true;
      },
      selectDocument() {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_MODE, {
          [this.$mixpanelPayload.MODE]: 'manual'
        });
        this.$router.push({
          name: 'Show Bank Statement',
        });
      },
      thirdPartyMethodCall(docType) {
        this.toggleModal();
        if (docType === 'Get Instant Verification') {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_MODE, {
            [this.$mixpanelPayload.MODE]: 'instant'
          });
          this.getInstantVerification();
        } else {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_MODE, {
            [this.$mixpanelPayload.MODE]: 'net_banking'
          });
          this.initiateNetBanking();
        }
      },
      getInstantVerification() {
        this.isSpinLoading = true;
        this.$store
          .dispatch('createConsentOneMoney', {
          })
          .then((result) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_CONSENT_API, {
              [this.$mixpanelPayload.RESPONSE]: result,
            });
            this.$emit("toggleInstantVerification");
            if (result?.status === "success") {
              window.microapps.openUrl({ url: result?.data?.webRedirectionUrl });
            }
            this.isSpinLoading = false;
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_CONSENT_API, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message,
            });
            this.isSpinLoading = false;
          });
      },
      initiateNetBanking() {
        this.isSpinLoading = true;
        this.$store
          .dispatch('perfiosNetbanking', {
            applicationId: this.applicationId,
          })
          .then((result) => {
            document.querySelector('#app').innerHTML += result;
            document.autoform.submit();
            this.isSpinLoading = false;
          })
          .catch(() => {
            this.isSpinLoading = false;
          });
      },
  }
};
  </script>

  <style lang="scss" scoped>
  .info-popup {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .popup-dialog {
    color: black;
    position: absolute;
    top: 100%;
    left: -5px;
    background-color: white;
    padding: 10px;
    border-radius: 10px 6px 10px 10px;
    box-shadow: 0 3px 10px #00000014;
    z-index: 1;
    width: 10rem;
  }
  .popup-pointer {
    position: absolute;
    top: -10px;
    left: 6%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }
  .info-popup:hover .popup-dialog {
    display: block;
  }
  </style>
